import { getLocalState, removeLocalState } from "../../utils/localStorage";

export default function authHeader(): Record<string, string> {
    const token = getLocalState('access_token');
    const expiresAt = getLocalState('tokenExpiresAt');

    // Check if token exists and is not expired
    if (token && expiresAt) {
        const now = new Date();
        const expiration = new Date(expiresAt);

        if (now < expiration) {
            return {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`
            };
        } else {
            // Token expired, clean up
            removeLocalState('access_token');
            removeLocalState('refresh_token');
            removeLocalState('tokenExpiresAt');
            removeLocalState('_currentUser');
        }
    } else if (token && !expiresAt) {
        // Token without expiration date - stale, clean up
        removeLocalState('access_token');
        removeLocalState('refresh_token');
        removeLocalState('tokenExpiresAt');
        removeLocalState('_currentUser');
    }

    return {
        "Content-Type": "application/json"
    };
}
